import React from "react";
import SideTableNotifications from "../Admin-pages/CA-admin-pages/Communications/SideTableNotifications";
import CaSideNav from "../../components/AdminComponents/CaSideNav";
import {
  SecondaryNavUser,
  UserTopLevel,
} from "../../components/AdminComponents/MenuItems";
import SecondaryNav from "../../components/AdminComponents/SecondaryNav2";

const UserNotifications = () => {
  return (
    <CaSideNav props={UserTopLevel}>
      <SecondaryNav menuItems={SecondaryNavUser} />
      <SideTableNotifications from={"USER"} />
    </CaSideNav>
  );
};

export default UserNotifications;
